import React, { useEffect } from 'react';
import { useApp } from '../context/AppContext';
import Icon from './Icon';
import './Drawer.css';

export default function Drawer({ id, title, icon, children, footer, width = 460 }) {
  const { drawer, closeDrawer } = useApp();
  const open = drawer.open === id;
  useEffect(() => {
    const onEsc = (e) => e.key === 'Escape' && closeDrawer();
    if (open) {
      window.addEventListener('keydown', onEsc);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      window.removeEventListener('keydown', onEsc);
      document.body.style.overflow = '';
    };
  }, [open, closeDrawer]);

  if (!open) return null;
  return (
    <div className="nx-drawer" role="dialog" aria-modal="true">
      <div className="nx-drawer__backdrop" onClick={closeDrawer} />
      <aside className="nx-drawer__panel" style={{ width }}>
        <header className="nx-drawer__head">
          <h3>
            {icon && <Icon name={icon} size={18} />} {title}
          </h3>
          <button
            className="nx-drawer__close"
            onClick={closeDrawer}
            aria-label="Close"
          >
            <Icon name="close" size={16} />
          </button>
        </header>
        <div className="nx-drawer__body">{children}</div>
        {footer && <footer className="nx-drawer__foot">{footer}</footer>}
      </aside>
    </div>
  );
}
